import { render, staticRenderFns } from "./OrderWithGoods.vue?vue&type=template&id=642ea4b7&scoped=true"
import script from "./OrderWithGoods.vue?vue&type=script&lang=js"
export * from "./OrderWithGoods.vue?vue&type=script&lang=js"
import style0 from "./OrderWithGoods.vue?vue&type=style&index=0&id=642ea4b7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642ea4b7",
  null
  
)

export default component.exports